import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Scrollable from '~/views/Home/base/Scrollable'
import oget from 'oget'
import groupLapTimesMarkLowestTime from '../../../../utils/groupLapTimesMarkLowestTime'

export default class CurrentScoresScored extends Component {
  static propTypes = {
    athleteLive: PropTypes.object.isRequired,
    deviceType: PropTypes.any.isRequired,
    t: PropTypes.func.isRequired,
  }

  render () {
    const {
      athleteLive,
      deviceType,
      t,
      colors
    } = this.props

    const lapTimes = groupLapTimesMarkLowestTime(oget(
      athleteLive,
      'details.LapTimes.values',
      []
    ), deviceType)
    let scrollableClasses = 'laptimes'
    scrollableClasses += (lapTimes.length > 1) ? ' grouped' : ' not-grouped'
    return (
      <div className="current-scores-timed">
          {lapTimes
            .map((laps, lapIndex) => {
              return <Scrollable className={scrollableClasses} key={`scrollable_${lapIndex}`}>
                {laps.map(({ Lap, Laptime, isLowest }, i) => {
                const style = (isLowest)
                  ? colors.leaderboard.itemActive
                  : (i % 2 === 0)
                    ? colors.headerScores.laptimeRowEven
                    : colors.headerScores.laptimeRowOdd

                return (
                  <div
                    key={`header_scores_laptimes_${i}`}
                    className="laptimes-row"
                    style={style}
                  >
                                <span className="num">
                                    {t('Lap')} {Lap}
                                </span>
                    {' '}
                    <span className="time">
                                    {Laptime}
                                </span>
                  </div>
                )
              })}
            </Scrollable>
          })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/header/HeaderScores/CurrentScoresTimed.js